import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useShiftPlusOffer() {
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    api.get("/offers").then((r) => setOffer(r.data)).catch(() => setOffer(null));
  }, []);
  return offer?.shift_plus_first_month_usd ? offer : null;
}

export const FirstMonthOfferBanner = () => {
  const offer = useShiftPlusOffer();
  const { user } = useAuth();
  if (!offer || user?.is_member || user?.member_until) return null;

  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-6 py-4 sm:py-8" data-testid="home-first-month-offer">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Link
          to="/membership?plan=shift_society"
          className="group block border border-accent bg-accent/5 rounded-sm p-6 sm:p-10 relative overflow-hidden"
          data-testid="home-first-month-offer-link"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 items-center">
            <div className="md:col-span-2">
              <div className="flex items-center gap-3 mb-4 flex-wrap">
                <span className="eyebrow flex items-center gap-2"><Sparkles className="h-3 w-3 text-accent" /> New member offer</span>
                <span className="font-mono text-[10px] tracking-[0.28em] uppercase bg-accent text-accent-foreground px-2 py-1 rounded-full">
                  Limited
                </span>
              </div>
              <h3 className="font-serif text-2xl sm:text-4xl leading-tight mb-3">
                Your first month of Shift+ for{" "}
                <span className="italic text-accent" data-testid="home-offer-price">${offer.shift_plus_first_month_usd}</span>
              </h3>
              <p className="text-muted-foreground text-sm sm:text-base leading-relaxed max-w-xl">
                Step into the private room — members-only teachings, the private Discord, and the monthly live Q&A with Tay.
                Then ${offer.shift_plus_monthly_usd}/mo after your first month.
              </p>
            </div>
            <div className="md:col-span-1 flex md:justify-end">
              <span className="inline-flex items-center gap-2 font-mono tracking-[0.24em] uppercase text-xs text-accent group-hover:gap-3 transition-all">
                Claim my first month <ArrowRight className="h-4 w-4" />
              </span>
            </div>
          </div>
        </Link>
      </motion.div>
    </section>
  );
};
